module.exports = __webpack_public_path__ + "img/China.a38ea87e.png";